import { z } from "zod";

/** Настройки календаря (строка `salon_settings` с module = 'calendar'). Владеет этап 2. */
export const CalendarSettingsSchema = z.object({
  /** Шаг сетки слотов в минутах. */
  slotStepMin: z.number().int().min(5).max(120).default(15),
  /** Насколько раньше текущего момента нельзя записаться (минут). */
  minLeadMin: z.number().int().min(0).max(1440).default(30),
  /** На сколько дней вперёд показываем слоты. */
  horizonDays: z.number().int().min(1).max(90).default(30),
  /** Опоздание, после которого мастерам уходит уведомление, а бот предлагает перенос. */
  lateArrivalToleranceMin: z.number().int().min(0).max(120).default(15),
  /** Отмена позже чем за N часов помечается как поздняя (принимается всё равно). */
  lateCancelHours: z.number().int().min(0).max(168).default(3),
  /** Сколько минут живёт удержание слота, пока клиент подтверждает. */
  holdTtlMin: z.number().int().min(1).max(60).default(10),
  /** На один телефон не больше N активных записей (страница записи). */
  maxActiveBookingsPerPhone: z.number().int().min(1).max(10).default(2),
});

export type CalendarSettings = z.infer<typeof CalendarSettingsSchema>;
export const defaultCalendarSettings = (): CalendarSettings => CalendarSettingsSchema.parse({});
